module.exports = __webpack_public_path__ + "img/fullscreen.18f17913.svg";